import { useState } from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
// import Button from '@mui/material/Button';
// import TextField from '@mui/material/TextField';
import classes from './Email.module.css';

const Email = props => {
  const [noShow, setNoShow] = useState(false);

  const hideEmailHanlder = alias => () => {
    setNoShow(true);
    props.deleteEmail(alias, 1, 'DELETE');
  };

  return (
    <aside
      className={noShow ? classes.noShow : classes.emailContainer}
    >
      <p className={classes.email}>{props.email.alias}</p>
      {props.email.alias.includes(
        'universidaddelasciencias.edu.mx'
      ) ? (
        ''
      ) : (
        <IconButton
          onClick={hideEmailHanlder(props.email.alias)}
          className={classes.deleteEmailBtn}
        >
          <DeleteOutlinedIcon className={classes.deleteEmailIcon} />
        </IconButton>
      )}
    </aside>
  );
};

Email.propTypes = {
  // eslint-disable-next-line react/require-default-props
  email: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  deleteEmail: PropTypes.func
};

export default Email;
